import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/Layout'

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      redirect: '/index',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'Index',
          component: () => import('@/views/Index/Index'),
          meta: { title: '首页' }
        },
        //二级页面
        {
          path: 'jinCaiSecond',
          name: 'jinCaiSecond',
          component: () => import('@/views/jinCaiSecond/index'),
          meta: { title: '晋彩华章' }
        },
        //二级页面博览之窗
        {
          path: 'boLanSecond',
          name: 'boLanSecond',
          component: () => import('@/views/boLanSecond/index'),
          meta: { title: '博览之窗' }
        },
        {
          path: 'shuZiSecond',
          name: 'shuZiSecond',
          component: () => import('@/views/shuZiSecond/index'),
          meta: { title: '数字视界' }
        },
        {
          path: 'changChengSecond',
          name: 'changChengSecond',
          component: () => import('@/views/changChengSecond/index'),
          meta: { title: '长城纵横' }
        },
        {
          path: 'bimoSecond',
          name: 'bimoSecond',
          component: () => import('@/views/bimoSecond/index'),
          meta: { title: '笔墨丹青' }
        },
        {
          path: 'youXueSecond',
          name: 'youXueSecond',
          component: () => import('@/views/youXueSecond/index'),
          meta: { title: '游学行纪' }
        },
        {
          path: 'zhengYanSecond',
          name: 'zhengYanSecond',
          component: () => import('@/views/zhengYanSecond/index'),
          meta: { title: '正言汇' }
        },
        {
          path: 'login',
          name: 'login',
          component: () => import('@/views/login/Index'),
          meta: { title: '登录' }
        }, {
          path: 'userlogin',
          name: 'userlogin',
          component: () => import('@/views/userlogin/Index'),
          meta: { title: '会员中心' }
        }, {
          path: 'register',
          name: 'register',
          component: () => import('@/views/register/Index'),
          meta: { title: '注册' }
        }, {
          path: 'treaty',
          name: 'treaty',
          component: () => import('@/views/treaty/Index'),
          meta: { title: '注册协议' }
        }, {
          path: 'reset',
          name: 'reset',
          component: () => import('@/views/reset/Index'),
          meta: { title: '忘记密码' }
        }, {
          path: 'search',
          name: 'Search',
          component: () => import('@/views/search/Index'),
          meta: { title: '全局搜索' }
        },
        //三级页面
        {
          path: 'jinYunThird',
          name: 'jinYunThird',
          component: () => import('@/views/jinYunThird/index'),
          meta: { title: '三级页面' }
        },
        //长城三级
        {
          path: 'changChengThird',
          name: 'changChengThird',
          component: () => import('@/views/changChengThird/index'),
          meta: { title: '长城三级页面' }
        },
        {
          path: 'changChengThirdDetail',
          name: 'changChengThirdDetail',
          component: () => import('@/views/changChengThirdDetail/index'),
          meta: { title: '长城三级页面' }
        },
        //四级页面
        {
          path: 'jinYunFourth',
          name: 'jinYunFourth',
          component: () => import('@/views/jinYunFourth/index'),
          meta: { title: '四级页面' }
        },
    

  
       
    
       


      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js